document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('[data-bike-builder]')
    .forEach(function (builder) {
      initBikeBuilder(builder);
    });
});


function initBikeBuilder(builder) {

  /* =====================================================
     VARIANT JSON
  ===================================================== */

  const variantsElement =
    builder.querySelector('[data-bike-variants]');

  if (!variantsElement) {
    return;
  }

  let variants = [];

  try {
    variants =
      JSON.parse(variantsElement.textContent);
  } catch (error) {
    console.error(
      'Bike Builder: Could not read variant JSON.',
      error
    );

    return;
  }

  if (!variants.length) {
    return;
  }


  /* =====================================================
     ELEMENTS
  ===================================================== */

  const variantInput =
    builder.querySelector(
      '[data-bike-variant-id]'
    );

  const totalElement =
    builder.querySelector(
      '[data-bike-total]'
    );

  const addButton =
    builder.querySelector(
      '[data-bike-add]'
    );

  const priceChangeBox =
    builder.querySelector(
      '[data-bike-price-change]'
    );

  const priceChangeAmount =
    builder.querySelector(
      '[data-bike-price-change-amount]'
    );

  const unitToggle =
    builder.querySelector(
      '[data-bike-unit-toggle]'
    );


  /* =====================================================
     MAIN PRODUCT PRICE
  ===================================================== */

  const productPage =
    builder.closest(
      '[data-main-product]'
    );

  const mainPrice =
    productPage
      ? productPage.querySelector(
          '.product-blocks__block--product_info h2.h5'
        )
      : null;


  const currency =
    builder.dataset.currency || 'NZD';


  /* =====================================================
     BASE PRODUCT PRICE

     Cheapest Shopify variant is treated as the base
     configuration.
  ===================================================== */

  const variantPrices =
    variants.map(function (variant) {
      return variant.price;
    });

  const baseVariantPrice =
    Math.min.apply(
      null,
      variantPrices
    );


  /* =====================================================
     MONEY FORMAT

     Builder:
     $3,900.00

     Main product price:
     NZD $3,900.00
  ===================================================== */

  function formatMoney(cents) {

    try {

      return new Intl.NumberFormat(
        'en-NZ',
        {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'narrowSymbol'
        }
      ).format(cents / 100);

    } catch (error) {

      return (
        '$' +
        (cents / 100).toFixed(2)
      );

    }

  }


  function formatMainPrice(cents) {

    return (
      currency +
      ' ' +
      formatMoney(cents)
    );

  }


  /* =====================================================
     GET CURRENT SHOPIFY VARIANT SELECTIONS
  ===================================================== */

  function getSelections() {

    const selections = [];

    builder
      .querySelectorAll(
        '[data-option-position]'
      )
      .forEach(function (group) {

        const position =
          parseInt(
            group.dataset.optionPosition,
            10
          ) - 1;

        const selected =
          group.querySelector(
            '[data-bike-option].is-selected'
          );

        if (selected) {

          selections[position] =
            selected.dataset.value;

        }

      });

    return selections;

  }


  /* =====================================================
     FIND EXACT VARIANT
  ===================================================== */

  function findVariant(selections) {

    if (!selections) {
      selections =
        getSelections();
    }

    return variants.find(
      function (variant) {

        return variant.options.every(
          function (
            optionValue,
            index
          ) {

            return (
              optionValue ===
              selections[index]
            );

          }
        );

      }
    );

  }


  /* =====================================================
     AVAILABILITY

     A choice remains selectable if the Shopify variant
     exists.

     If that variant is sold out, the option can still be
     selected but Add to Cart will be disabled.
  ===================================================== */

  function updateAvailability() {

    const currentSelections =
      getSelections();

    builder
      .querySelectorAll(
        '[data-bike-option]'
      )
      .forEach(function (button) {

        const position =
          parseInt(
            button.dataset.position,
            10
          ) - 1;

        const testSelections =
          currentSelections.slice();

        testSelections[position] =
          button.dataset.value;

        const matchingVariant =
          findVariant(
            testSelections
          );

        if (matchingVariant) {

          button.disabled =
            false;

          button.classList.remove(
            'is-unavailable'
          );

        } else {

          button.disabled =
            true;

          button.classList.add(
            'is-unavailable'
          );

        }

      });

  }


  /* =====================================================
     OPTION PRICE DIFFERENCE

     Example:

     Shimano 105

     Shimano Ultegra
     (+$501.00)
  ===================================================== */

  function updateChoicePrices() {

    const currentSelections =
      getSelections();

    const groups = {};

    builder
      .querySelectorAll(
        '[data-bike-option]'
      )
      .forEach(function (button) {

        const position =
          parseInt(
            button.dataset.position,
            10
          ) - 1;

        if (!groups[position]) {
          groups[position] = [];
        }

        const testSelections =
          currentSelections.slice();

        testSelections[position] =
          button.dataset.value;

        const variant =
          findVariant(
            testSelections
          );

        groups[position].push({
          button: button,
          variant: variant
        });

      });


    Object.keys(groups)
      .forEach(function (position) {

        const choices =
          groups[position];

        const prices =
          choices
            .filter(
              function (choice) {
                return !!choice.variant;
              }
            )
            .map(
              function (choice) {
                return choice.variant.price;
              }
            );

        if (!prices.length) {
          return;
        }

        const lowestPrice =
          Math.min.apply(
            null,
            prices
          );

        choices.forEach(
          function (choice) {

            const priceHolder =
              choice.button.querySelector(
                '[data-choice-price]'
              );

            if (!priceHolder) {
              return;
            }

            if (!choice.variant) {

              priceHolder.textContent =
                '';

              return;

            }

            const difference =
              choice.variant.price -
              lowestPrice;

            if (difference > 0) {

              priceHolder.textContent =
                '(+' +
                formatMoney(
                  difference
                ) +
                ')';

            } else {

              priceHolder.textContent =
                '';

            }

          }
        );

      });

  }


  /* =====================================================
     MAIN "SELECTION WILL ADD" MESSAGE
  ===================================================== */

  function updatePriceDifference(
    variant
  ) {

    if (
      !priceChangeBox ||
      !priceChangeAmount ||
      !variant
    ) {
      return;
    }

    const difference =
      variant.price -
      baseVariantPrice;

    if (difference > 0) {

      priceChangeAmount.textContent =
        formatMoney(
          difference
        );

      priceChangeBox.hidden =
        false;

    } else {

      priceChangeBox.hidden =
        true;

    }

  }


  /* =====================================================
     UPDATE MAIN PRODUCT PRICE UNDER TITLE

     Output:
     NZD $3,900.00

     Main price is red and bold to match the other
     CycleNet product pages.
  ===================================================== */

  function updateMainPrice(
    priceInCents
  ) {

    if (!mainPrice) {
      return;
    }

    mainPrice.textContent =
      formatMainPrice(
        priceInCents
      );

    mainPrice.style.color =
      '#e60000';

    mainPrice.style.fontWeight =
      '700';

  }


  /* =====================================================
     UPDATE CURRENT VARIANT
  ===================================================== */

  function updateVariant() {

    const selections =
      getSelections();

    const variant =
      findVariant(
        selections
      );


    /* -----------------------------------------------------
       INVALID COMBINATION
    ----------------------------------------------------- */

    if (!variant) {

      if (variantInput) {

        variantInput.value =
          '';

      }

      if (addButton) {

        addButton.disabled =
          true;

        addButton.textContent =
          'Unavailable Combination';

      }

      if (priceChangeBox) {

        priceChangeBox.hidden =
          true;

      }

      updateAvailability();

      updateChoicePrices();

      return;

    }


    /* -----------------------------------------------------
       VARIANT ID
    ----------------------------------------------------- */

    if (variantInput) {

      variantInput.value =
        variant.id;

    }


    /* -----------------------------------------------------
       PRICE
    ----------------------------------------------------- */

    const formattedPrice =
      formatMoney(
        variant.price
      );

    if (totalElement) {

      totalElement.textContent =
        formattedPrice;

    }


    /*
     * Main product price:
     * NZD $3,900.00
     */

    updateMainPrice(
      variant.price
    );


    updatePriceDifference(
      variant
    );


    /* -----------------------------------------------------
       ADD TO CART BUTTON
    ----------------------------------------------------- */

    if (addButton) {

      if (variant.available) {

        addButton.disabled =
          false;

        addButton.textContent =
          'Add to Cart — ' +
          formattedPrice;

      } else {

        addButton.disabled =
          true;

        addButton.textContent =
          'Sold out — ' +
          formattedPrice;

      }

    }


    /* -----------------------------------------------------
       UPDATE URL
    ----------------------------------------------------- */

    try {

      const url =
        new URL(
          window.location.href
        );

      url.searchParams.set(
        'variant',
        variant.id
      );

      window.history.replaceState(
        {},
        '',
        url.toString()
      );

    } catch (error) {

      console.warn(
        'Bike Builder: URL could not be updated.',
        error
      );

    }


    /* -----------------------------------------------------
       REFRESH OPTIONS
    ----------------------------------------------------- */

    updateAvailability();

    updateChoicePrices();

  }


  /* =====================================================
     SHOPIFY VARIANT BUTTON CLICKS
  ===================================================== */

  builder
    .querySelectorAll(
      '[data-bike-option]'
    )
    .forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          if (button.disabled) {
            return;
          }

          const position =
            button.dataset.position;

          builder
            .querySelectorAll(
              '[data-bike-option]' +
              '[data-position="' +
              position +
              '"]'
            )
            .forEach(
              function (item) {

                item.classList.remove(
                  'is-selected'
                );

              }
            );

          button.classList.add(
            'is-selected'
          );

          updateVariant();

        }
      );

    });


  /* =====================================================
     CUSTOM BIKE OPTIONS

     These do NOT change the Shopify variant.

     Examples:

     Stem
     Bar Width
     Crankarm
  ===================================================== */

  builder
    .querySelectorAll(
      '[data-property-row]'
    )
    .forEach(function (row) {

      const hiddenInput =
        row.querySelector(
          '[data-bike-property-input]'
        );

      row
        .querySelectorAll(
          '[data-bike-property-option]'
        )
        .forEach(
          function (button) {

            button.addEventListener(
              'click',
              function () {

                row
                  .querySelectorAll(
                    '[data-bike-property-option]'
                  )
                  .forEach(
                    function (item) {

                      item.classList.remove(
                        'is-selected'
                      );

                    }
                  );

                button.classList.add(
                  'is-selected'
                );


                /*
                 * Keep actual metric value
                 * submitted to Shopify.
                 */

                if (hiddenInput) {

                  hiddenInput.value =
                    button.dataset.value;

                }

              }
            );

          }
        );

    });


  /* =====================================================
     LEARN MORE
  ===================================================== */

  builder
    .querySelectorAll(
      '[data-bike-help-toggle]'
    )
    .forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          const row =
            button.closest(
              '.bike-option-row'
            );

          if (!row) {
            return;
          }

          const help =
            row.querySelector(
              '.bike-option-help'
            );

          if (!help) {
            return;
          }

          if (help.hidden) {

            help.hidden =
              false;

            button.textContent =
              'CLOSE';

          } else {

            help.hidden =
              true;

            button.textContent =
              'LEARN MORE';

          }

        }
      );

    });


  /* =====================================================
     IMPERIAL / METRIC
  ===================================================== */

  let currentUnit =
    'metric';


  /* -----------------------------------------------------
     STORE ORIGINAL METRIC LABELS
  ----------------------------------------------------- */

  builder
    .querySelectorAll(
      '.bike-option-card__label'
    )
    .forEach(function (label) {

      if (
        !label.dataset.metricLabel
      ) {

        label.dataset.metricLabel =
          label.textContent.trim();

      }

    });


  /* -----------------------------------------------------
     MM -> INCH
  ----------------------------------------------------- */

  function mmToInches(mm) {

    return (
      parseFloat(mm) /
      25.4
    );

  }


  /* -----------------------------------------------------
     CM -> INCH
  ----------------------------------------------------- */

  function cmToInches(cm) {

    return (
      parseFloat(cm) /
      2.54
    );

  }


  /* -----------------------------------------------------
     FORMAT DECIMAL
  ----------------------------------------------------- */

  function cleanDecimal(number) {

    return Number(
      number.toFixed(2)
    );

  }


  /* -----------------------------------------------------
     CONVERT LABEL TO IMPERIAL
  ----------------------------------------------------- */

  function convertLabelToImperial(
    metricText,
    row
  ) {

    if (!metricText) {
      return metricText;
    }

    const heading =
      row
        ? row.querySelector(
            '.bike-option-row__heading'
          )
        : null;

    const headingText =
      heading
        ? heading.textContent
            .toLowerCase()
        : '';


    /* -----------------------------------------------------
       EXPLICIT MM IN LABEL
    ----------------------------------------------------- */

    if (
      /mm/i.test(
        metricText
      )
    ) {

      return metricText.replace(
        /([\d.]+)\s*mm/gi,
        function (
          match,
          number
        ) {

          return (
            cleanDecimal(
              mmToInches(
                number
              )
            ) +
            ' in'
          );

        }
      );

    }


    /* -----------------------------------------------------
       EXPLICIT CM IN LABEL
    ----------------------------------------------------- */

    if (
      /cm/i.test(
        metricText
      )
    ) {

      return metricText.replace(
        /([\d.]+)\s*cm/gi,
        function (
          match,
          number
        ) {

          return (
            cleanDecimal(
              cmToInches(
                number
              )
            ) +
            ' in'
          );

        }
      );

    }


    /* -----------------------------------------------------
       ROW HEADING SAYS (MM)

       Example:

       360 / 380

       becomes:

       14.17 / 14.96 in
    ----------------------------------------------------- */

    if (
      headingText.includes(
        '(mm)'
      )
    ) {

      const converted =
        metricText.replace(
          /[\d.]+/g,
          function (number) {

            return cleanDecimal(
              mmToInches(
                number
              )
            );

          }
        );

      return (
        converted +
        ' in'
      );

    }


    /*
     * Unknown unit:
     * Leave unchanged.
     */

    return metricText;

  }


  /* =====================================================
     UPDATE DISPLAY UNIT
  ===================================================== */

  function updateUnitDisplay() {

    builder
      .querySelectorAll(
        '.bike-option-card__label'
      )
      .forEach(function (label) {

        const metricValue =
          label.dataset.metricLabel ||
          label.textContent.trim();

        const row =
          label.closest(
            '.bike-option-row'
          );

        if (
          currentUnit ===
          'metric'
        ) {

          label.textContent =
            metricValue;

        } else {

          label.textContent =
            convertLabelToImperial(
              metricValue,
              row
            );

        }

      });


    if (unitToggle) {

      if (
        currentUnit ===
        'metric'
      ) {

        unitToggle.classList.add(
          'is-metric'
        );

        unitToggle.setAttribute(
          'aria-pressed',
          'true'
        );

      } else {

        unitToggle.classList.remove(
          'is-metric'
        );

        unitToggle.setAttribute(
          'aria-pressed',
          'false'
        );

      }

    }

  }


  /* =====================================================
     UNIT TOGGLE
  ===================================================== */

  if (unitToggle) {

    unitToggle.addEventListener(
      'click',
      function () {

        currentUnit =
          currentUnit ===
          'metric'
            ? 'imperial'
            : 'metric';

        updateUnitDisplay();

      }
    );

  }


  /* =====================================================
     INITIAL LOAD
  ===================================================== */

  updateUnitDisplay();

  updateVariant();

}